var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled, css } from "../utils";
import StatusTag from './StatusTag';
var StyledContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  text-align: center;\n  margin: 2rem 0;\n\n  hr {\n    position: absolute;\n    top: 50%;\n    width: 100%;\n    height: 2px;\n    margin: -1px 0 0 0;\n  }\n"], ["\n  position: relative;\n  text-align: center;\n  margin: 2rem 0;\n\n  hr {\n    position: absolute;\n    top: 50%;\n    width: 100%;\n    height: 2px;\n    margin: -1px 0 0 0;\n  }\n"])));
var StyledStatusTag = styled(StatusTag)(function (_a) {
    var color = _a.color, backgroundColor = _a.backgroundColor, bg = _a.bg, colors = _a.theme.colors;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    position: relative;\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    position: relative;\n  "])), color || colors.primary, backgroundColor || bg || colors.secondary);
});
var Legend = function (_a) {
    var children = _a.children, _b = _a.withSeparator, withSeparator = _b === void 0 ? false : _b, props = __rest(_a, ["children", "withSeparator"]);
    return (React.createElement(React.Fragment, null, withSeparator ? (React.createElement(StyledContainer, null,
        React.createElement("hr", null),
        React.createElement(StyledStatusTag, __assign({}, props), children))) : (React.createElement(StyledStatusTag, __assign({}, props), children))));
};
export default Legend;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Legend.js.map